import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .menu-item, & .header-phone-link': {
      textTransform: 'none !important',
    },
    '& .MuiButton-root:not(.topbar-signup-cta)': {
      textTransform: 'none !important',
    },
    '& .topbar-signup-cta': {
      minHeight: '48px',
      minWidth: '144px',
      padding: '12px 20px !important',
      fontSize: '16px !important',
      fontWeight: 400,
      fontFamily: 'Lato !important',
      textTransform: 'uppercase !important',
      letterSpacing: '-0.32px',
      lineHeight: '20px !important',
      backgroundColor: `${palette.primary.main} !important`,
      color: `${palette.text.highlight} !important`,
      border: `1px solid ${palette.text.blueBorder} !important`,
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.text.blueBorder} !important`,
        opacity: 0.92,
      },
    },
  },

  '.group-parent-container': {
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'Lato !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 0,
      background: `${palette.primary.main} !important`,
      backgroundColor: `${palette.primary.main} !important`,
      backgroundImage: 'none !important',
      backgroundSize: 'unset !important',
      borderBottom: 'none !important',
      maxHeight: 'none !important',
      marginBottom: '0 !important',
      overflow: 'hidden',
      '& > .section, & > section': {
        background: `${palette.primary.main} !important`,
        backgroundColor: `${palette.primary.main} !important`,
        padding: '80px 40px !important',
        maxWidth: 'none !important',
        margin: '0 !important',
        '@media(max-width: 1024px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .section-header': {
        alignItems: 'center !important',
        textAlign: 'center !important',
        marginBottom: '32px !important',
      },
      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper': {
        justifyContent: 'center !important',
        textAlign: 'center !important',
      },
      '& .hero-header-title': {
        fontFamily: 'Lato !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 500,
        color: `${palette.text.highlight} !important`,
        textAlign: 'center !important',
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Lato !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        fontWeight: 400,
        color: `${palette.text.highlight} !important`,
        textAlign: 'center !important',
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
      '& .header-container': {
        justifyContent: 'center !important',
        margin: '0 !important',
        '& > .MuiGrid-item': {
          flexGrow: '0 !important',
          maxWidth: 'none !important',
        },
      },
      '& .hero-link-button, & .hero-link-button.MuiButton-containedPrimary': {
        minHeight: '44px',
        minWidth: 'auto',
        width: 'auto !important',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.primary.brand} !important`,
        border: `1px solid ${palette.primary.brand} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.primary.brand} !important`,
          opacity: 0.92,
        },
      },
      '& .hero-home-button, & .hero-home-button.MuiButton-outlinedSecondary': {
        minHeight: '44px',
        minWidth: 'auto',
        width: 'auto !important',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: 'transparent !important',
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.background.border} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
          color: `${palette.text.highlight} !important`,
          borderColor: `${palette.background.border} !important`,
          opacity: 0.92,
        },
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: 0,
    },
    '& .home-hero-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      /* Desktop: full-bleed background image with overlaid copy (Figma) */
      '@media(min-width: 960px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-end',
        width: '100%',
        aspectRatio: '1920 / 624',
        minHeight: '624px',
        height: 'auto !important',
        maxHeight: 'none !important',
      },
      '& .hero-background': {
        /* Desktop: full-bleed cover (overrides MFE contain + object-position: right) */
        '@media(min-width: 960px)': {
          position: 'absolute !important',
          top: 0,
          left: 0,
          width: '100% !important',
          height: '100% !important',
          maxWidth: 'none !important',
          objectFit: 'cover !important',
          objectPosition: 'center center',
          zIndex: 0,
        },
        '@media(max-width: 959px)': {
          position: 'absolute !important',
          top: 0,
          left: 0,
          width: '100% !important',
          height: '100% !important',
          maxWidth: 'none !important',
          objectFit: 'cover !important',
          objectPosition: 'center center !important',
          zIndex: 0,
        },
        '@media(min-width: 601px) and (max-width: 959px)': {
          objectPosition: 'center top !important',
        },
      },
      '& .hero-section': {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2,
        maxHeight: 'none',
        width: '100% !important',
        maxWidth: 'none !important',
        margin: '0 auto',
        boxShadow: 'none',
        '@media(min-width: 960px)': {
          paddingBottom: '80px',
          minHeight: '0 !important',
          flex: '1 1 auto',
        },
        '& .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 960px)': {
            minHeight: '0 !important',
          },
        },
        '& .section-alternate__content > .MuiGrid-container': {
          '@media(max-width: 600px)': {
            justifyContent: 'flex-start !important',
          },
          '@media(min-width: 601px) and (max-width: 959px)': {
            justifyContent: 'center !important',
          },
        },
        '& .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 600px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
        },
        '& .section-alternate__content': {
          backgroundColor: 'transparent',
          width: '100% !important',
          maxWidth: '100% !important',
          '@media(min-width: 960px)': {
            padding: '0 80px !important',
          },
          '@media(max-width: 1200px) and (min-width: 960px)': {
            padding: '0 50px !important',
          },
          '@media(max-width: 959px)': {
            padding: '0 24px !important',
          },
        },
        '& .section-header': {
          width: '100%',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '100%',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
          marginTop: 0,
          '@media(max-width: 600px)': {
            textAlign: 'left',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '@media(min-width: 601px) and (max-width: 959px)': {
            textAlign: 'center !important',
            justifyContent: 'center !important',
            alignItems: 'center !important',
          },
          '& .section-header__overline-wrapper': {
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              justifyContent: 'center !important',
            },
            color: `${palette.text.highlight} !important`,
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
            maxWidth: '800px !important',
            width: '100%',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            '@media(max-width: 600px)': {
              marginLeft: 0,
              marginRight: 'auto',
              justifyContent: 'flex-start !important',
            },
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'center !important',
            maxWidth: '800px !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            '@media(max-width: 600px)': {
              textAlign: 'left !important',
              marginLeft: 0,
              marginRight: 'auto',
            },
          },
          '& .section-header__subtitle-wrapper': {
            display: 'none !important',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            marginTop: '32px !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            '@media(max-width: 600px)': {
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
          },
          '& .section-header__cta-container': {
            flexWrap: 'nowrap',
            justifyContent: 'center !important',
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
          },
          '& .section-header__cta-item-wrapper': {
            gap: '24px !important',
            justifyContent: 'center !important',
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'Lato',
        fontWeight: 500,
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        lineHeight: '72px !important',
        letterSpacing: '-3.2px',
        whiteSpace: 'pre-line',
        color: `${palette.text.highlight} !important`,
        '@media(max-width: 1280px) and (min-width: 960px)': {
          fontSize: '48px !important',
          lineHeight: '52px !important',
          letterSpacing: '-2.4px !important',
        },
        '@media(max-width: 959px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-2px !important',
          '@media(max-width: 600px)': {
            textAlign: 'left !important',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '@media(min-width: 601px)': {
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
        },
      },
      '& .home-hero-subtitle': {
        display: 'none !important',
      },
      '& .hero-link-button': {
        minHeight: '44px',
        minWidth: 'auto',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        color: `${palette.text.highlight} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.primary.brand} !important`,
          opacity: 0.92,
        },
      },
      '& .login-button': {
        minHeight: '44px',
        minWidth: 'auto',
        padding: '12px 32px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: `${palette.background.default} !important`,
        color: `${palette.primary.main} !important`,
        border: `1px solid ${palette.primary.main} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
          color: `${palette.text.highlight} !important`,
          borderColor: `${palette.primary.main} !important`,
          opacity: 0.92,
        },
      },
      /* Mobile + tablet: full-bleed image with bottom overlay */
      '@media(max-width: 959px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-end',
        position: 'relative',
        minHeight: '640px',
        height: '640px',
        maxHeight: 'none !important',
        paddingTop: '0 !important',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        '& .hero-section': {
          order: 2,
          position: 'relative !important',
          zIndex: 2,
          flex: '1 1 auto !important',
          display: 'flex !important',
          alignItems: 'flex-end !important',
          height: '100% !important',
          minHeight: 'auto !important',
          maxHeight: 'none !important',
          backgroundColor: 'transparent !important',
          paddingBottom: '63px !important',
        },
        '& .hero-section .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
        '& .section-alternate__content': {
          padding: '0 24px !important',
          backgroundColor: 'transparent !important',
        },
        '@media(max-width: 600px)': {
          '& .section-header': {
            display: 'flex',
            justifyContent: 'flex-start !important',
            textAlign: 'left !important',
            marginLeft: '0 !important',
            marginRight: 'auto !important',
            maxWidth: '100% !important',
          },
          '& .section-header__overline-wrapper, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
            {
              justifyContent: 'flex-start !important',
              textAlign: 'left !important',
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
          '& .section-header__cta-container': {
            justifyContent: 'flex-start !important',
          },
        },
      },
      /* Tablet: same overlay layout as mobile, centered copy, show top of image */
      '@media(min-width: 601px) and (max-width: 959px)': {
        minHeight: '780px',
        height: '780px',
        '& .hero-section': {
          alignItems: 'flex-end !important',
          justifyContent: 'center !important',
          paddingBottom: '63px !important',
          '& .section-alternate__content > .MuiGrid-container': {
            justifyContent: 'center !important',
          },
          '& .section-header': {
            textAlign: 'center !important',
            justifyContent: 'center !important',
            alignItems: 'center !important',
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
          },
        },
        '& .section-alternate__content': {
          padding: '0 40px !important',
        },
        '& .hero-section .section-header': {
          justifyContent: 'center !important',
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
          alignItems: 'center !important',
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            maxWidth: '800px !important',
            width: '100%',
            flexBasis: 'auto !important',
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'center !important',
            maxWidth: '800px !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
          },
          '& .section-header__cta-item-wrapper': {
            justifyContent: 'center !important',
          },
        },
        '& .hero-section .home-hero-title': {
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.benefits,
      backgroundColor: palette.background.benefits,
      '& .definition-variant-2': {
        background: 'transparent',
      },
      '& .benefits-wrapper': {
        maxWidth: '1280px',
        margin: '0 auto',
        width: '100%',
      },
      '& .section-header': {
        alignItems: 'flex-start !important',
        marginBottom: '72px !important',
        '@media(max-width: 900px)': {
          marginBottom: '48px !important',
        },
      },
      '& .section-header__title-wrapper': {
        justifyContent: 'flex-start !important',
      },
      '& .section-header__subtitle-wrapper': {
        display: 'none !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'Lato !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-0.96px !important',
        color: `${palette.text.content} !important`,
        textAlign: 'left !important',
        paddingBottom: '0 !important',
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
      '& .definition-benefits-grid': {
        display: 'grid !important',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr)) !important',
        gap: '32px !important',
        margin: '0 !important',
        width: '100% !important',
        '@media(max-width: 900px)': {
          gridTemplateColumns: '1fr !important',
          gap: '40px !important',
        },
        '& > .MuiGrid-item': {
          padding: '0 !important',
          display: 'flex',
          maxWidth: 'none !important',
          flexBasis: 'auto !important',
          width: 'auto !important',
        },
      },
      '& .definition-service-tile': {
        border: 'none !important',
        backgroundColor: 'transparent !important',
        padding: '0 !important',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      },
      '& .definition-service-innertile': {
        border: 'none !important',
        borderRadius: '0 !important',
        backgroundColor: 'transparent !important',
        padding: '0 !important',
        margin: '0 !important',
        width: '100% !important',
        height: '100%',
        boxSizing: 'border-box',
        justifyContent: 'flex-start !important',
        alignItems: 'flex-start !important',
        flexDirection: 'column !important',
        flexWrap: 'nowrap !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: '100% !important',
          width: '100% !important',
          flexBasis: 'auto !important',
          flexGrow: '0 !important',
          flexShrink: '0 !important',
        },
      },
      '& .definition-service-innertile > .MuiGrid-item.customIcon': {
        marginBottom: '32px !important',
      },
      '& .definition-service-innertile > .MuiGrid-item.definition-service-description-wrapper': {
        marginTop: '16px !important',
      },
      '& .customIcon': {
        justifyContent: 'flex-start !important',
        padding: '0 !important',
        margin: '0 !important',
        maxWidth: '100% !important',
        flexBasis: 'auto !important',
        '& .image, & img': {
          width: '56px !important',
          height: '56px !important',
          display: 'block',
        },
      },
      '& .definition-service-title': {
        fontWeight: 500,
        fontFamily: 'Lato !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: `${palette.text.secondary} !important`,
        textAlign: 'left !important',
        padding: '0 !important',
        margin: '0 !important',
        maxWidth: '100% !important',
        flexBasis: 'auto !important',
        '@media(max-width: 600px)': {
          fontSize: '22px !important',
          lineHeight: '26px !important',
        },
      },
      '& .definition-service-description-wrapper': {
        maxWidth: '100% !important',
        flexBasis: 'auto !important',
        padding: '0 !important',
        margin: '0 !important',
      },
      '& .definition-service-description': {
        margin: '0 !important',
        padding: '0 !important',
        fontFamily: 'Lato !important',
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: `${palette.text.secondary} !important`,
        textAlign: 'left !important',
        letterSpacing: '-0.64px !important',
      },
      '& #definition-section.definition-variant-2': {
        padding: '96px 80px !important',
        '@media(max-width: 1200px) and (min-width: 600px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .section-alternate__content': {
        padding: '0 !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      /* Tablet: Figma node 10050:26535 — stacked full-width cards */
      '@media screen and (min-width: 600px) and (max-width: 1024px)': {
        padding: '0 !important',
      },
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label': {
        color: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'Lato !important',
        fontSize: '48px !important',
        lineHeight: '72px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 1024px) and (min-width: 600px)': {
          fontSize: '48px !important',
          lineHeight: '64px !important',
          letterSpacing: '-2.4px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Lato !important',
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        color: `${palette.text.highlight} !important`,
        '@media screen and (max-width: 1024px) and (min-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.72px !important',
        },
        '@media screen and (max-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        /* One card per row below lg (1200), centered — covers tablet + narrow desktop carousel */
        '@media screen and (min-width: 600px) and (max-width: 1199px)': {
          '& .carousel-container, & .carousel-single-item.MuiGrid-container': {
            maxWidth: '100% !important',
            width: '100%',
            margin: '0 auto !important',
            justifyContent: 'center !important',
            alignItems: 'center !important',
            flexDirection: 'column !important',
          },
          '& .carousel-single-item > .MuiGrid-item, & .subscription-plan-card-item': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            marginBottom: '40px !important',
            boxSizing: 'border-box',
            display: 'flex !important',
            justifyContent: 'center !important',
          },
          '& .carousel-single-item > .MuiGrid-item:last-child, & .subscription-plan-card-item:last-child': {
            marginBottom: '0 !important',
          },
          '& .planCard': {
            maxWidth: '100% !important',
            width: '100% !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            boxSizing: 'border-box',
          },
        },
        '@media screen and (min-width: 600px) and (max-width: 1024px)': {
          padding: '80px 56px !important',
          '& > .section-alternate__content.subscription-section, & .subscription-section': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            maxWidth: '100%',
          },
          '& .section-header': {
            maxWidth: '100% !important',
            paddingLeft: '80px',
            paddingRight: '80px',
            boxSizing: 'border-box',
          },
        },
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '4px !important',
          border: 'none !important',
          color: `${palette.text.content} !important`,
          '&:hover': {
            color: palette.text.content,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.tertiaryLight,
            },
          },
          '& .customGetStarted, & .MuiButton-containedPrimary.customGetStarted': {
            backgroundColor: `${palette.background.buttonTertiary} !important`,
            color: `${palette.text.content} !important`,
            border: 'none !important',
            boxShadow: 'none !important',
            '& .MuiButton-label': {
              color: `${palette.text.content} !important`,
            },
            '&:hover': {
              backgroundColor: `${palette.primary.brand} !important`,
              color: `${palette.text.highlight} !important`,
              opacity: 1,
              boxShadow: 'none !important',
              '& .MuiButton-label': {
                color: `${palette.text.highlight} !important`,
              },
            },
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'Lato !important',
            fontSize: '32px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.64px !important',
            color: `${palette.text.content} !important`,
          },
          '& .price-value': {
            fontWeight: 400,
            fontSize: '32px !important',
            fontFamily: 'Lato !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: `${palette.text.content} !important`,
            '@media screen and (max-width: 600px)': {
              fontSize: '32px !important',
              lineHeight: '32px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .price-frequency, & .display-frequency, & .customSubscriberName': {
            color: `${palette.text.tertiaryLight} !important`,
          },
          '& .MuiTypography-body2': {
            color: `${palette.text.content} !important`,
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 400,
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontFamily: 'Lato !important',
              color: `${palette.text.content} !important`,
            },
            '& .cptCodes': {
              fontSize: '14px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.28px !important',
              fontWeight: 400,
              fontFamily: 'Lato !important',
              color: `${palette.text.content} !important`,
            },
          },
          '& .customUpfrontWrapper': {
            color: `${palette.text.tertiary} !important`,
            fontWeight: 400,
            fontFamily: 'Lato !important',
            lineHeight: '16px !important',
            letterSpacing: '-0.36px !important',
            fontStyle: 'normal',
          },
          '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
            },
            '& .disclaimerText': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato !important',
              color: `${palette.text.tertiary} !important`,
            },
            '& .bold': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato !important',
              color: `${palette.text.tertiary} !important`,
              fontStyle: 'normal',
            },
            '& .MuiTypography-body2': {
              fontFamily: 'Lato !important',
              color: `${palette.text.tertiary} !important`,
            },
          },
          /* Tablet plan card layout (Figma 10050:26535) */
          '@media screen and (min-width: 600px) and (max-width: 1024px)': {
            borderRadius: '12px !important',
            '& .customCardContent, & .MuiCardContent-root': {
              padding: '32px 24px !important',
            },
            '& .customcardTitle, & .description-cta__title': {
              fontSize: '24px !important',
              lineHeight: '28px !important',
              letterSpacing: '-0.96px !important',
              fontWeight: 500,
              textAlign: 'left !important',
            },
            '& .description-cta, & .description-cta__wrapper, & .titleContainer, & .cardTitleContainer': {
              justifyContent: 'flex-start !important',
              textAlign: 'left !important',
            },
            '& .customPlanDescription > .MuiGrid-container': {
              display: 'flex !important',
              flexWrap: 'nowrap !important',
              alignItems: 'center !important',
              gap: '24px',
            },
            '& .price-item': {
              maxWidth: 'calc(50% - 12px) !important',
              flexBasis: 'calc(50% - 12px) !important',
              width: 'auto !important',
              paddingTop: '0 !important',
              paddingBottom: '0 !important',
            },
            '& .price-item + .price-item': {
              borderLeft: `1px solid ${palette.background.border} !important`,
              paddingLeft: '24px !important',
            },
            '& .price-value': {
              fontSize: '36px !important',
              lineHeight: '40px !important',
              letterSpacing: '-1.44px !important',
              fontWeight: 500,
            },
            '& .customButtonWrapper': {
              width: '100% !important',
              marginLeft: '0 !important',
              marginRight: '0 !important',
            },
            '& .customButtonWrapper > .MuiGrid-item': {
              maxWidth: '100% !important',
              flexBasis: '100% !important',
              width: '100% !important',
            },
            '& .customGetStarted, & .MuiButton-containedPrimary.customGetStarted': {
              width: '100% !important',
              backgroundColor: `${palette.primary.main} !important`,
              color: `${palette.text.highlight} !important`,
              borderRadius: '999px !important',
              border: 'none !important',
              boxShadow: 'none !important',
              fontWeight: 400,
              textTransform: 'none !important',
              '& .MuiButton-label': {
                color: `${palette.text.highlight} !important`,
              },
              '&:hover': {
                backgroundColor: `${palette.primary.main} !important`,
                color: `${palette.text.highlight} !important`,
                opacity: 0.92,
                '& .MuiButton-label': {
                  color: `${palette.text.highlight} !important`,
                },
              },
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
          '& .carousel-container': {
            maxWidth: '100% !important',
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0,
            boxSizing: 'border-box',
          },
          '& .react-multi-carousel-item > div': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
          '& .carousel-single-item.MuiGrid-container': {
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            maxWidth: '100%',
          },
          '& .subscription-plan-card-item': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
          '& .planCard': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
        },
        '& .bold': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          color: `${palette.text.tertiaryLight} !important`,
          fontFamily: 'Lato !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
          },
        },
        '& .summary-text': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.8px !important',
          fontFamily: 'Lato !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.8px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: `${palette.background.main} !important`,
      backgroundColor: `${palette.background.main} !important`,
      borderTop: 'none !important',
      '& .section': {
        padding: '96px 80px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .howitworks-wrapper': {
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 !important',
        width: '100%',
      },
      '& .howitworks-grid': {
        display: 'grid !important',
        gridTemplateColumns: '1fr 1fr',
        gap: '120px !important',
        margin: '0 !important',
        width: '100% !important',
        alignItems: 'center',
        '@media(max-width: 900px)': {
          gridTemplateColumns: '1fr',
          gap: '40px !important',
        },
        '& > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: 'none !important',
          flexBasis: 'auto !important',
          width: 'auto !important',
        },
        '& > .cover-image-wrapper.MuiGrid-item': {
          width: '100% !important',
          minWidth: '0 !important',
        },
      },
      '& .howitworks-wrapper-left': {
        padding: '0 !important',
        '& > .MuiGrid-container': {
          margin: '0 !important',
          width: '100%',
          '& > .MuiGrid-item': {
            padding: '0 !important',
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
          },
        },
      },
      '& .howitworks-content-grid': {
        margin: '0 !important',
        width: '100% !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
      },
      '& .howitworks-title': {
        marginBottom: '64px !important',
        '& .section-header': {
          alignItems: 'flex-start !important',
          marginBottom: '0 !important',
        },
        '& .section-header__title-wrapper': {
          justifyContent: 'flex-start !important',
          marginBottom: '12px !important',
        },
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Lato !important',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-0.96px !important',
          fontWeight: 500,
          color: `${palette.text.content} !important`,
          textAlign: 'left !important',
          padding: '0 !important',
          margin: '0 !important',
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '40px !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 500,
          fontFamily: 'Lato !important',
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.4px !important',
          color: `${palette.text.secondary} !important`,
          textAlign: 'left !important',
          margin: '0 !important',
          padding: '0 !important',
          '@media(max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '24px !important',
          },
        },
      },
      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '24px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
          maxWidth: '600px !important',
          marginLeft: 'auto',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
        },
      },
      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: `${palette.primary.brand} !important`,
        color: `${palette.text.highlight} !important`,
        fontSize: '14px !important',
        fontWeight: 500,
        fontFamily: 'Lato !important',
        letterSpacing: '-0.28px !important',
        lineHeight: '20px !important',
        width: '40px !important',
        height: '40px !important',
        minWidth: '40px !important',
        flexShrink: 0,
        margin: '0 !important',
        padding: '0 !important',
      },
      '& .working-steps-main-container': {
        width: '100%',
        display: 'flex !important',
        flexDirection: 'column !important',
        gap: '32px !important',
      },
      '& .working-steps-container': {
        maxWidth: 'none',
        width: '100%',
        margin: '0 !important',
        marginTop: '0 !important',
        padding: '0 !important',
        display: 'flex !important',
        flexWrap: 'nowrap !important',
        alignItems: 'flex-start !important',
        gap: '24px',
        borderBottom: 'none !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
        '& .step-title': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 500,
          fontFamily: 'Lato !important',
          color: `${palette.text.content} !important`,
          padding: '0 !important',
          margin: '0 0 10px 0 !important',
        },
        '& .step-content': {
          fontSize: '16px !important',
          color: `${palette.text.secondary} !important`,
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
          fontWeight: 400,
          fontFamily: 'Lato !important',
          margin: '0 !important',
          padding: '0 !important',
        },
      },
      '& .working-steps-main-container > .working-steps-container:not(:last-child)': {
        paddingBottom: '32px !important',
        marginBottom: '0 !important',
        borderBottom: `1px solid ${palette.background.border} !important`,
      },
      '& .working-steps-container:not(:last-child)::after': {
        display: 'none !important',
      },
      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `${palette.primary.main} !important`,
        backgroundColor: `${palette.primary.main} !important`,
        backgroundImage: 'none !important',
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'Lato !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'Lato !important',
          fontSize: '18px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .MuiTableCell-head': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 500,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.tableHead} !important`,
      },
      '& .footer-bar-text': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-containedSecondary, & .view-more-button': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.text.blueBorder} !important`,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
        fontFamily: 'Lato !important',
        textTransform: 'uppercase !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.primary} !important`,
          opacity: 0.92,
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      position: 'relative',
      background: `${palette.background.dark} !important`,
      borderTop: 'none !important',
      padding: '64px 80px !important',
      '@media(max-width: 1024px)': {
        padding: '48px 40px !important',
      },
      '@media(max-width: 600px)': {
        padding: '48px 20px !important',
      },
      '& .hero-static-bg': {
        display: 'none !important',
      },
      '& .section-alternate.hero-static-section': {
        maxWidth: '1280px !important',
        width: '100%',
        margin: '0 auto !important',
        overflow: 'visible !important',
        padding: '0 !important',
      },
      '& .section-alternate': {
        '& .section-alternate__content': {
          background: 'transparent !important',
          border: 'none !important',
          borderRadius: '0 !important',
          padding: '0 !important',
          width: '100%',
          boxSizing: 'border-box',
        },
      },
      '& .section-header': {
        alignItems: 'flex-start !important',
        marginBottom: '0 !important',
      },
      '& .section-header__title-wrapper': {
        justifyContent: 'flex-start !important',
        marginBottom: '12px !important',
      },
      '& .section-header__title, & .hero-static-title': {
        color: `${palette.text.highlight} !important`,
        fontWeight: 500,
        fontFamily: 'Lato !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.36px !important',
        textAlign: 'left !important',
        padding: '0 !important',
        margin: '0 !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '34px !important',
          letterSpacing: '-0.3px !important',
        },
      },
      '& .section-header__subtitle, & .hero-static-subtitle': {
        color: `${palette.text.highlight} !important`,
        opacity: 0.8,
        fontWeight: 400,
        fontFamily: 'Lato !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        textAlign: 'left !important',
        margin: '0 !important',
        padding: '0 !important',
      },
      '& .hero-static-section-grid': {
        margin: '0 !important',
        width: '100% !important',
        display: 'flex !important',
        flexWrap: 'wrap',
        alignItems: 'center !important',
        justifyContent: 'space-between !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button, & .MuiButton-root': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.primary.main} !important`,
          border: 'none !important',
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-1.12px !important',
          fontWeight: 500,
          fontFamily: 'Lato !important',
          textTransform: 'none !important',
          padding: '12px 20px !important',
          minHeight: 'auto',
          boxShadow: 'none !important',
          '&:hover': {
            backgroundColor: `${palette.text.highlight} !important`,
            color: `${palette.primary.main} !important`,
            opacity: 0.92,
            boxShadow: 'none !important',
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-end !important',
          flex: '0 0 auto',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-start !important',
          marginTop: '24px !important',
          width: '100%',
        },
      },
      '@media(max-width: 900px)': {
        '& .section-header__title, & .hero-static-title, & .section-header__subtitle, & .hero-static-subtitle':
          {
            textAlign: 'left !important',
          },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Lato !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Lato !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .price-value': {
            fontFamily: 'Lato !important',
          },
          '& .customGetStarted, & .MuiButton-containedPrimary.customGetStarted': {
            backgroundColor: `${palette.background.buttonTertiary} !important`,
            color: `${palette.text.content} !important`,
            border: 'none !important',
            boxShadow: 'none !important',
            '& .MuiButton-label': {
              color: `${palette.text.content} !important`,
            },
            '&:hover': {
              backgroundColor: `${palette.primary.brand} !important`,
              color: `${palette.text.highlight} !important`,
              opacity: 1,
              boxShadow: 'none !important',
              '& .MuiButton-label': {
                color: `${palette.text.highlight} !important`,
              },
            },
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 400,
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontFamily: 'Lato !important',
              color: `${palette.text.content} !important`,
            },
            '& .cptCodes': {
              fontSize: '14px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.28px !important',
              fontWeight: 400,
              fontFamily: 'Lato !important',
              color: `${palette.text.content} !important`,
            },
          },
          '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
              color: `${palette.text.tertiary} !important`,
              fontFamily: 'Lato !important',
              fontStyle: 'normal',
            },
            '& .disclaimerText': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato !important',
              color: `${palette.text.tertiary} !important`,
            },
            '& .bold': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato !important',
              color: `${palette.text.tertiary} !important`,
              fontStyle: 'normal',
            },
            '& .MuiTypography-body2': {
              fontFamily: 'Lato !important',
              color: `${palette.text.tertiary} !important`,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-wrapper': {
      '& .faqInnerContainer, & .faq-contact-section': {
        fontFamily: 'Lato !important',
        '& .MuiTypography-root, & .MuiTab-root, & .faq-link, & .MuiButton-root': {
          fontFamily: 'Lato !important',
        },
      },
    },
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& .header-container': {
        margin: '0 !important',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '0 !important',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.content,
      },
      '& .faq-link': {
        fontSize: '15px !important',
        textTransform: 'none !important',
        fontFamily: 'Lato !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1, & .accorion_item-title': {
          fontFamily: 'Lato !important',
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
          color: `${palette.text.content} !important`,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontFamily: 'Lato !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.background.benefits} !important`,
      borderTop: 'none !important',
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      padding: '96px 80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 600px) ': {
        padding: '48px 20px !important',
      },
      '& .contact-img-wrapper': {
        width: '56px',
        maxWidth: '56px',
        minHeight: '56px',
        minWidth: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        backgroundColor: 'transparent',
        border: 'none',
        '& img': {
          width: '56px',
          height: '56px',
        },
      },
      '& .contact-card-title': {
        fontFamily: 'Lato !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 400,
        color: `${palette.text.content} !important`,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontFamily: 'Lato !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'Lato !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'Lato !important',
        fontWeight: 400,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'Lato',
        fontWeight: 400,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
      /* Not now (left) | Login (right) — match Figma order */
      '& > .MuiGrid-item:last-child > .MuiGrid-container': {
        flexDirection: 'row-reverse',
      },
      /* Login — solid green pill (same look as Book Appointment in mockup) */
      '& a.MuiButton-containedPrimary, & .MuiButton-containedPrimary': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: 'none !important',
        boxShadow: 'none !important',
        borderRadius: '999px !important',
        fontFamily: 'Lato !important',
        fontWeight: 500,
        textTransform: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          opacity: 0.92,
          boxShadow: 'none !important',
        },
      },
      /* Not now — outlined white with light gray border */
      '& .cancel-button, & .cancel-button.MuiButton-outlinedSecondary, & .cancel-button.MuiButton-containedSecondary': {
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.text.content} !important`,
        border: `1px solid ${palette.background.border} !important`,
        boxShadow: 'none !important',
        borderRadius: '999px !important',
        fontFamily: 'Lato !important',
        fontWeight: 400,
        textTransform: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.text.content} !important`,
          border: `1px solid ${palette.background.border} !important`,
          opacity: 0.92,
          boxShadow: 'none !important',
        },
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.benefits,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      color: `${palette.text.highlight} !important`,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
      '& p, & span, & .MuiTypography-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& a, & .footer-link, & .copyrights-footer-link, & .MuiButton-root, & .MuiLink-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-label': {
        color: `${palette.text.highlight} !important`,
      },
    },
  },
};
